'use strict';
const mmWidgets = require('../widgets/mm-widgets');
require('./show-progress-message');
require('./section-handler-widget');
mmWidgets.fn.changeCardWidget = function (subscriptionModel, navigatorShim, taskBuilder) {
	return mmWidgets.each(this, function () {
		let currrentTask;
		const widget = this.sectionHandlerWidget();
		subscriptionModel.addEventListener('showChangeCard', () => {
			const taskId = taskBuilder.newTaskId();

			navigatorShim.open(`/stripe-checkout-launch.html?launchType=update&taskId=${taskId}`, 'stripe-payments');
			widget.showProgressMessage('Waiting for new card details...');
			widget.removeClass('hidden');
			return taskBuilder.build(taskId)
			.then(task => {
				currrentTask = task;
				return currrentTask.waitFor(taskMetadata => taskMetadata && taskMetadata.status === 'succeeded');
			})
			.then(() => {
				widget.showSection('card-updated');
				return subscriptionModel.getGoldAccountDetails(true);
			})
			.then(() => widget.trigger('changeCard:complete'));
		});
		subscriptionModel.addEventListener('showBillingPortal', () => {
			const taskId = taskBuilder.newTaskId();
			navigatorShim.redirect(`/stripe-checkout-launch.html?launchType=portal&taskId=${taskId}`);
		});
		widget.on('hide', () => {
			if (currrentTask) {
				return currrentTask.cancelIfWaiting();
			}
		});
	});
};
